
import React, { useState, useEffect, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaChevronRight, FaChevronLeft, FaPhoneAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";

import IssamImage from "../assets/user.png";
import OmranImage from "../assets/user.png";
import HadeelImage from "../assets/user.png";
import HaifaaImage from "../assets/user.png";

const testimonials = [
  {
    name: "Issam AL-Harthi",
    phone: "95566512",
    email: "issam@unitedom.net",
    quote: "General Manager",
    image: IssamImage,
  },
  {
    name: "Omran Hamed",
    phone: "94180189",
    email: "omran@unitedom.net",
    quote: "Art Director",
    image: OmranImage,
  },
  {
    name: "Hadeel AL-Harthy",
    phone: "79054754",
    email: "hadeel@unitedom.net",
    quote: "Events Assistant",
    image: HadeelImage,
  },
  {
    name: "Haifaa AL-Barwani",
    phone: "94422271",
    email: "haifaa@unitedom.net",
    quote: "Events Manager",
    image: HaifaaImage,
  },
];

export default function OurTeam() {
  const [active, setActive] = useState(0);
  const intervalRef = useRef(null);

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setActive((prev) => (prev + 1) % testimonials.length);
    }, 6000);
    return () => clearInterval(intervalRef.current);
  }, []);

  const handleNext = () => setActive((prev) => (prev + 1) % testimonials.length);
  const handlePrev = () => setActive((prev) => (prev - 1 + testimonials.length) % testimonials.length);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 text-center">
      {/* Profile image section */}
      <div className="relative flex flex-col items-center mb-12">
        <div className="absolute w-72 h-72 sm:w-96 sm:h-96 rounded-full bg-gradient-to-b from-[#2f1b71]/60 via-[#2f1b71]/30 to-transparent blur-2xl"></div>
        <AnimatePresence mode="wait">
          {testimonials.map((t, i) =>
            i === active ? (
              <motion.img
                key={`img-${i}`}
                src={t.image}
                alt={t.name}
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.8 }}
                transition={{ duration: 0.6 }}
                className="w-24 h-24 ring-2 ring-black sm:w-32 sm:h-32 rounded-full object-cover relative z-10"
              />
            ) : null
          )}
        </AnimatePresence>
      </div>

      {/* Quote text */}
      <div className="text-lg sm:text-2xl font-medium text-zinc-700 dark mb-8 min-h-[64px] px-4">
        <AnimatePresence mode="wait">
          {testimonials.map((t, i) =>
            i === active ? (
              <motion.div
                key={`quote-${i}`}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.5 }}
              >
                “{t.quote}”
              </motion.div>
            ) : null
          )}
        </AnimatePresence>
      </div>

      {/* Navigation and details section */}
      <div className="relative w-full max-w-6xl mx-auto">
        {/* Desktop Left Arrow */}
        <button
          className="hidden lg:flex absolute left-0 top-1/2 transform -translate-y-1/2 bg-gray-100 dark:bg-neutral-700 hover:bg-gray-300 dark:hover:bg-neutral-600 p-3 rounded-full shadow-md transition-transform hover:scale-110"
          onClick={handlePrev}
        >
          <FaChevronLeft className="text-2xl text-zinc-700 dark:text-white" />
        </button>

        {/* Profile Info */}
        <div className="flex flex-col items-center gap-2 text-center px-8">
          <div className="text-xl font-semibold text-zinc-900 ">{testimonials[active].name}</div>
          <div className="flex items-center gap-2 text-sm text-gray-500 dark:text-gray-400">
            <FaPhoneAlt className="text-base" />
            <span>{testimonials[active].phone}</span>
          </div>
          <div className="flex items-center gap-2 text-sm text-gray-500 dark:text-gray-400">
            <MdEmail className="text-base" />
            <span>{testimonials[active].email}</span>
          </div>
        </div>

        {/* Desktop Right Arrow */}
        <button
          className="hidden lg:flex absolute right-0 top-1/2 transform -translate-y-1/2 bg-gray-100 dark:bg-neutral-700 hover:bg-gray-300 dark:hover:bg-neutral-600 p-3 rounded-full shadow-md transition-transform hover:scale-110"
          onClick={handleNext}
        >
          <FaChevronRight className="text-2xl text-zinc-700 dark:text-white" />
        </button>

        {/* Mobile Arrows */}
        <div className="flex justify-center gap-8 mt-8 lg:hidden">
          <button
            className="bg-gray-100 dark:bg-neutral-700 hover:bg-gray-300 dark:hover:bg-neutral-600 p-3 rounded-full shadow-md transition-transform hover:scale-110"
            onClick={handlePrev}
          >
            <FaChevronLeft className="text-xl text-zinc-700 dark:text-white" />
          </button>
          <button
            className="bg-gray-100 dark:bg-neutral-700 hover:bg-gray-300 dark:hover:bg-neutral-600 p-3 rounded-full shadow-md transition-transform hover:scale-110"
            onClick={handleNext}
          >
            <FaChevronRight className="text-xl text-zinc-700 dark:text-white" />
          </button>
        </div>
      </div>
    </div>
  );
}